export const DRAWER_WIDTH = 240;
export const DRAWER_WIDTH_COLLAPSED = 60; // MUI's default is theme.spacing(7) + 1px which is ~57px. Let's use 60 for simplicity.
export const HEADER_HEIGHT = 64;